<mat-card style="padding-bottom: 10px;">
    <app-matspinner *ngIf="isLoading"></app-matspinner>
    <mat-card-header>
      <mat-card-title class="title">Pharmacy Store Search</mat-card-title>
    </mat-card-header>
    <mat-divider  class="divider" style="margin-bottom: 8%;"></mat-divider>
    <mat-card-content>
      <br>
      <form [formGroup]="form" (ngSubmit)="submitForm()">
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenState = true"
            (closed)="panelOpenState = false" [expanded]="true">
            <mat-expansion-panel-header style="height: 30px;">
            </mat-expansion-panel-header>
            <div class="container">
              <div class="row form-row">
                <div class="col-md-2">
                  <label class="lbl_fld">Pharmacy Chain Name</label>
                </div>
                <div class="col-md-4">
                  <mat-form-field class="ffs" appearance="outline">
                    <input
                      matInput
                      type="text"
                      name="PharmacyChain"
                      (keyup)="onInputkeyup($event)"
                      formControlName="PharmacyChain"
                      placeholder="Select Pharmacy Chain Name"
                      aria-label="Pharmacy Chain"
                      [matAutocomplete]="autochain"
                      ngDefaultControl
                    >
                    <mat-autocomplete #autochain="matAutocomplete" (optionSelected)="onPharmacyChainChange($event)" [displayWith]="displayTextForChain" id="PharmacyChain">
                      <mat-option *ngFor="let chain of filteredOptions | async" [value]="chain">{{chain.PharmacyName}}</mat-option>
                    </mat-autocomplete>
                    <mat-error
                      *ngIf="form.get('PharmacyChain')?.invalid && (form.get('PharmacyChain')?.touched || form.get('PharmacyChain')?.dirty)">
                      Invalid pharmacy chain name entered
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-2">
                  <label class="lbl_fld">Pharmacy NCPDP ID</label>
                </div>
                <div class="col-md-4">
                  <mat-form-field class="ffs" appearance="outline">
                    <input
                      matInput
                      type="text"
                      (keyup)="onInputkeyup($event)"
                      name="NCPDPID"
                      formControlName="NCPDPID"
                      placeholder="Pharmacy NCPDP ID (Max length is 7 characters)"
                      ngDefaultControl
                    >
                    <mat-error
                      *ngIf="form.get('NCPDPID')?.invalid && (form.get('NCPDPID')?.touched || form.get('NCPDPID')?.dirty)">
                      {{errorMessageForPharmacyNcpdpid}}
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" style="padding-top: 8px; padding-bottom: 8px;">
                <div class="col-md-12" style="text-align: center;">
                  <button [disabled]="!this.form.valid" mat-raised-button class="btn-save" type="submit">Search</button>
                  <button style="margin-left: 1%;" type="button" (click)="clearSearch()" mat-raised-button class="btn-cancel">Clear</button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
      <div class="store-search-row" *ngIf="dataSource!=null">
        <div class="form-group search-group">
          <mat-form-field class="ffs" appearance="outline" style="margin-left: 0%; font-size: 18px;">
            <input
              matInput
              type="text"
              (keyup)="applyFilter($event)"
              placeholder="Search"
              #input
              autocomplete="off"
            >
          </mat-form-field>
        </div>
        <div class="export-button" style="margin-right: 10%;">
          <button
            mat-raised-button
            type="button"
            class="btn-save"
            (click)="ExportToExcel()"
          >Export</button>
        </div>
      </div>
      <div id="transactionResultTable" class="mat-elevation-z8 table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table-container">
          <ng-container matColumnDef="NCPDPID">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> NCPDP ID </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.NCPDPID}} </td>
          </ng-container>
          <ng-container matColumnDef="NPI">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> NPI </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.NPI}} </td>
          </ng-container>
          <ng-container matColumnDef="PharmacyName">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> Pharmacy Chain Name </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.PharmacyName}} </td>
          </ng-container>
          <ng-container matColumnDef="PID">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> Vela PID </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.PID}} </td>
          </ng-container>
          <ng-container matColumnDef="IsEnabled">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> Pharmacy Chain Active </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.IsEnabled}} </td>
          </ng-container>
          <ng-container matColumnDef="RecordActiveDate">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> Store Active Date </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.RecordActiveDate}} </td>
          </ng-container>
          <ng-container matColumnDef="RecordDeactivateDate">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> Store Deactivate Date </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.RecordDeactivateDate}} </td>
          </ng-container>
          <ng-container matColumnDef="UpdatedDate">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> Last Changed Date </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.UpdatedDate}} </td>
          </ng-container>
          <ng-container matColumnDef="UpdatedBy">
            <th mat-header-cell *matHeaderCellDef class="table-header-font"> Last Changed By </th>
            <td mat-cell *matCellDef="let element" class="table-row-font"> {{element.UpdatedBy}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: !isLoading?true:false"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="7">No Stores Found for Pharmacy Chain / NCPDP ID</td>
          </tr>
        </table>
        <mat-paginator [length]="length" [pageSize]="pharmacyPagesize" [pageIndex]="pharmacyPageNumber - 1" [pageSizeOptions]="pageSizeOptions"
          (page)="onPageEvent($event)">
        </mat-paginator>
      </div>
    </mat-card-content>
    <br>
    <br>
  </mat-card>